import { render, staticRenderFns } from "./RedeemGift.vue?vue&type=template&id=31c7e74a&scoped=true"
import script from "./RedeemGift.vue?vue&type=script&lang=js"
export * from "./RedeemGift.vue?vue&type=script&lang=js"
import style0 from "./RedeemGift.vue?vue&type=style&index=0&id=31c7e74a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c7e74a",
  null
  
)

export default component.exports